// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` .dashboard_dashboard_overview_container__MZ26U{ 
  display: flex;
  flex:  5 1;
  flex-direction: column;
  align-items: flex-start;
  align-content: center;
  justify-content: center;
  background-color: var(--hsrcBackgroundLight);
  border-radius: 1rem;
  padding: 2rem;
 
 }

.dashboard_featured__4rGje {
  width: 100%;
  display: flex;
  flex: 1 1; 
  flex-direction: row;
} 

.dashboard_flex_row_container__ziYII{
  display: flex;
  flex-direction: row;
  flex: 1 1; 
  width: 100%; 
  align-items: flex-start;
    align-content: center;
    justify-content: center;
 
}`, "",{"version":3,"sources":["webpack://./src/pages/ResearcherDashboard/pages/Dashboard/dashboard.module.css"],"names":[],"mappings":"CAAC;EACC,aAAa;EACb,UAAQ;EACR,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;EACvB,4CAA4C;EAC5C,mBAAmB;EACnB,aAAa;;CAEd;;AAED;EACE,WAAW;EACX,aAAa;EACb,SAAO;EACP,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAO;EACP,WAAW;EACX,uBAAuB;IACrB,qBAAqB;IACrB,uBAAuB;;AAE3B","sourcesContent":[" .dashboard_overview_container{ \r\n  display: flex;\r\n  flex:  5;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  align-content: center;\r\n  justify-content: center;\r\n  background-color: var(--hsrcBackgroundLight);\r\n  border-radius: 1rem;\r\n  padding: 2rem;\r\n \r\n }\r\n\r\n.featured {\r\n  width: 100%;\r\n  display: flex;\r\n  flex: 1; \r\n  flex-direction: row;\r\n} \r\n\r\n.flex_row_container{\r\n  display: flex;\r\n  flex-direction: row;\r\n  flex: 1; \r\n  width: 100%; \r\n  align-items: flex-start;\r\n    align-content: center;\r\n    justify-content: center;\r\n \r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard_overview_container": `dashboard_dashboard_overview_container__MZ26U`,
	"featured": `dashboard_featured__4rGje`,
	"flex_row_container": `dashboard_flex_row_container__ziYII`
};
export default ___CSS_LOADER_EXPORT___;
